export default class CreatedInvoice {
    constructor(
        public readonly invoiceId: number | null
    ) {}
}